export const QuickAccessItems = [
    { to: { name: 'TypeOverview' }, locale: "property.type" },
    { to: { name: 'Political Map' }, locale: "routes.Political Map" },
    { to: { name: 'Additional Maps' }, locale: "routes.Additional Maps" },
]